import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import {
  getNgpTeamAssignmentQueries,
  ngpTeamAssignmentConfig,
  SamplingAssignmentMapPage,
} from '@sampling';

export const Route = createFileRoute('/_app/os/ngp-sampling-assignment')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(
      ctx.context.auth,
      Permission.NgpSamplerAssignment,
    );
  },
  loader: async ({ context }) => {
    const queries = getNgpTeamAssignmentQueries();
    await context.queryClient.prefetchQuery(queries.map());
    await context.queryClient.prefetchQuery(queries.samplers());
  },
  component: () => (
    <SamplingAssignmentMapPage config={ngpTeamAssignmentConfig()} />
  ),
});
